export const data = [
  {
    title: "Measurement Preference",
    text: "",
    options: [
      { id: "1", name: "preference", value: "Metric" },
      { id: "2", name: "preference", value: "Imperial" },
    ],
    type: "radio",
  },
  {
    title: "Primary Diet",
    text:
      "Controls which version of the recipe you see by default. All recipe diet can be switch on the recipe page.",
    options: [
      { id: "3", name: "Primary", value: "Omnivore" },
      { id: "4", name: "Primary", value: "Vegetarian" },
      { id: "5", name: "Primary", value: "Vegan" },
      { id: "6", name: "Primary", value: "Dairy Free" }, // ✅ moved here
    ],
    type: "radio",
  },
  {
    title: "Secondary Diet",
    text: "Every Primary Diet has Gluten Free options.",
    options: [{ id: "2", name: "Gluten Free", value: "Gluten Free" }],
    type: "switch",
  },
];
